import type React from "react";

import { faCommentExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { BaseButton } from "shared/atoms/BaseButton";

interface PatientViewStickyNoteProps {
  isCompactView?: boolean;
  stickyNoteMessage: string;
  setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PatientViewStickyNote: React.FC<PatientViewStickyNoteProps> = ({
  isCompactView,
  stickyNoteMessage,
  setIsEditing,
}) => {
  const { t } = useTranslation();
  const isDefault = stickyNoteMessage === "";
  return (
    <StickyNoteContainer className={clsx({ compact: isCompactView })} data-testid="patient-sticky-note">
      <Container>
        <FontAwesomeIcon icon={faCommentExclamation} style={{ color: "#307FE2" }} />
        <Typography variant="body1">{isDefault ? t("sticky_note.default") : stickyNoteMessage}</Typography>
      </Container>
      <Container>
        <BaseButton
          data-testid="edit-sticky-note"
          onClick={() => setIsEditing(true)}
          variant="action"
          icon="pen"
          text={t("buttons.write")}
          size="large"
        />
      </Container>
    </StickyNoteContainer>
  );
};

export const StickyNoteContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 24px 24px 24px;
  padding: 16px 24px;
  border-radius: 12px;
  background-color: ${props => props.theme.colors.redesign.b5};

  ${props => props.theme.belowBreakpoint} {
    margin: 0 12px;
  }

  &.compact {
    flex-direction: column;
    gap: 12px;

    button[data-testid="edit-sticky-note"] {
      margin-left: auto;
    }
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
